/**
 * MUI Components whose styles are overridden as per theme
 * @param {Object} theme - Plain JSON Object
 * @returns {Object} - Style overrides for MUI components
 */
export function componentStyleOverrides(theme) {
    console.log('Theme object:', theme); // Confirm theme structure

    return {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 500,
                    textTransform: 'capitalize',
                    borderRadius: '4px' // Default value or you can use theme.customization?.borderRadius
                }
            }
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0
            },
            styleOverrides: {
                root: {
                    backgroundImage: 'none'
                },
                rounded: {
                    borderRadius: (theme.borderRadius || 4) + 'px' // Use the borderRadius from theme
                }
            }
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    color: theme.colors?.textDark || 'defaultColor', // Ensure theme.colors exists
                    padding: '24px'
                },
                title: {
                    fontSize: '1.125rem'
                }
            }
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: '24px'
                }
            }
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    padding: '24px'
                }
            }
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary || 'defaultColor', // Ensure theme.darkTextPrimary exists
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    '&.Mui-selected': {
                        color: theme.menuSelected || 'defaultColor',
                        backgroundColor: theme.menuSelectedBack || 'defaultColor',
                        '&:hover': {
                            backgroundColor: theme.menuSelectedBack || 'defaultColor'
                        },
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected || 'defaultColor'
                        }
                    },
                    '&:hover': {
                        backgroundColor: theme.menuSelectedBack || 'defaultColor',
                        color: theme.menuSelected || 'defaultColor',
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected || 'defaultColor'
                        }
                    }
                }
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary || 'defaultColor',
                    minWidth: '36px'
                }
            }
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    color: theme.textDark || 'defaultColor' // Ensure theme.textDark exists
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    color: theme.textDark || 'defaultColor',
                    '&::placeholder': {
                        color: theme.darkTextSecondary || 'defaultColor',
                        fontSize: '0.875rem'
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    background: theme.colors?.grey50 || 'defaultColor',
                    borderRadius: (theme.borderRadius || 4) + 'px', // Use the borderRadius from theme
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.colors?.grey400 || 'defaultColor'
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.colors?.primaryLight || 'defaultColor'
                    },
                    '&.MuiInputBase-multiline': {
                        padding: 1
                    }
                },
                input: {
                    fontWeight: 500,
                    background: theme.colors?.grey50 || 'defaultColor',
                    padding: '15.5px 14px',
                    borderRadius: (theme.borderRadius || 4) + 'px', // Use the borderRadius from theme
                    '&.MuiInputBase-inputSizeSmall': {
                        padding: '10px 14px',
                        '&.MuiInputBase-inputAdornedStart': {
                            paddingLeft: 0
                        }
                    }
                },
                inputAdornedStart: {
                    paddingLeft: 4
                },
                notchedOutline: {
                    borderRadius: (theme.borderRadius || 4) + 'px' // Use the borderRadius from theme
                }
            }
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: theme.colors?.grey300 || 'defaultColor'
                    }
                },
                mark: {
                    backgroundColor: theme.paper || 'defaultColor',
                    width: '4px'
                },
                valueLabel: {
                    color: theme.colors?.primaryLight || 'defaultColor'
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: theme.divider || 'defaultColor',
                    opacity: 1
                }
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    color: theme.colors?.primaryDark || 'defaultColor',
                    background: theme.colors?.primary200 || 'defaultColor'
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    '&.MuiChip-deletable .MuiChip-deleteIcon': {
                        color: 'inherit'
                    }
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    color: theme.paper || 'defaultColor',
                    background: theme.colors?.grey700 || 'defaultColor'
                }
            }
        }
    };
}